// Período das pesquisas de documentos (épico PO1-2280). Mesmas regras da API
// (backend_hub pesquisa-documentos/helpers/pesquisaFiltros.js), conferidas
// também no front para avisar antes de consultar: sem chave nem número o
// período é obrigatório (padrão últimos 30 dias) e tem teto por tela (90 dias
// no CT-e, 365 na NF); com a chave completa (44 dígitos) ou o número o período
// é ignorado; com parte da chave o teto é de 31 dias (PO1-3904).
import moment from "moment";

export const DATE_FORMAT = "YYYY-MM-DD";
export const PERIODO_PADRAO_DIAS = 30;
export const TETO_DIAS_CHAVE_PARCIAL = 31;
const TAMANHO_CHAVE = 44;

const digitos = (valor) => String(valor == null ? "" : valor).replace(/\D/g, "");
export const chaveCompleta = (valor) => digitos(valor).length === TAMANHO_CHAVE;
export const chaveParcial = (valor) => String(valor == null ? "" : valor).trim() !== "" && !chaveCompleta(valor);

export const periodoPadrao = () => ({
  dataInicial: moment().subtract(PERIODO_PADRAO_DIAS, "days").format(DATE_FORMAT),
  dataFinal: moment().format(DATE_FORMAT),
});

export const atalhosDePeriodo = (tetoDias) =>
  [
    { label: "7 dias", days: 7 },
    { label: "30 dias", days: 30 },
    { label: "90 dias", days: 90 },
    { label: "180 dias", days: 180 },
    { label: "365 dias", days: 365 },
  ]
    .filter((a) => a.days <= tetoDias)
    .map((a) => ({
      ...a,
      getDates: () => ({
        dataInicial: moment().subtract(a.days, "days").format(DATE_FORMAT),
        dataFinal: moment().format(DATE_FORMAT),
      }),
    }));

export function diasEntre(dataInicial, dataFinal) {
  return moment(dataFinal, DATE_FORMAT).diff(moment(dataInicial, DATE_FORMAT), "days");
}

// Devolve a mensagem de erro ou null. `buscaDireta` = chave completa ou número
// preenchido; `comChaveParcial` = trecho de chave (teto curto, PO1-3904).
export function validarPeriodo({ dataInicial, dataFinal, buscaDireta, comChaveParcial }, tetoDias) {
  if (buscaDireta) return null;
  const temIni = Boolean(dataInicial);
  const temFim = Boolean(dataFinal);
  if (!temIni && !temFim) return null; // a API aplica os últimos 30 dias
  if (temIni !== temFim) return "Informe a data inicial e a data final.";
  if (dataInicial > dataFinal) return "A data inicial deve ser anterior à data final.";
  if (comChaveParcial && diasEntre(dataInicial, dataFinal) > TETO_DIAS_CHAVE_PARCIAL) {
    return `Com parte da chave, o período máximo é de ${TETO_DIAS_CHAVE_PARCIAL} dias. Para pesquisar fora dele, informe a chave completa (44 dígitos) ou o número.`;
  }
  if (diasEntre(dataInicial, dataFinal) > tetoDias) {
    return `O período máximo é de ${tetoDias} dias. Para pesquisar fora dele, informe a chave completa ou o número.`;
  }
  return null;
}

// Texto do período aplicado para o hint da busca.
export function descricaoPeriodo({ tipoData, dataInicial, dataFinal, buscaDireta }) {
  if (buscaDireta) return "Busca por chave completa/número (período ignorado)";
  const rotulo = tipoData === "importacao" ? "Importação" : "Emissão";
  const p = dataInicial && dataFinal ? { dataInicial, dataFinal } : periodoPadrao();
  const f = (d) => moment(d, DATE_FORMAT).format("DD/MM/YYYY");
  return `${rotulo} ${f(p.dataInicial)} a ${f(p.dataFinal)}`;
}
